import { writable } from 'svelte/store';
import { openOneConversation } from './single/index.js';
import { openConversationsView } from './list/index.js';
import {} from 'missiv';
import { API } from '../API.js';
const $store = { registered: { state: 'idle' } };
const store = writable($store);
function openConversationsList(config) {
    $store.conversations = openConversationsView(config, $store.currentUser);
    store.set($store);
}
export function setup(config) {
    let api;
    if (config) {
        openConversationsList(config);
        api = new API(config.endpoint);
    }
    function setCurrentUser(newUser) {
        const isNewUser = newUser?.address.toLowerCase() != $store.currentUser?.address.toLowerCase();
        if (isNewUser) {
            if (newUser?.address) {
                $store.registered = { state: 'loading' };
            }
            else {
                $store.registered = { state: 'idle' };
            }
        }
        $store.currentUser = newUser;
        if ($store.conversations) {
            $store.conversations.setCurrentUser(newUser);
        }
        store.set($store);
        if (isNewUser && newUser) {
            if (api && config) {
                api
                    .getDomainUser({
                    address: newUser.address,
                    domain: config.domain
                })
                    .then(({ domainUser }) => {
                    $store.registered = {
                        state: 'ready',
                        confirmed: domainUser ? true : false
                    };
                    store.set($store);
                });
            }
        }
    }
    async function register(signature, options) {
        if (api && config && $store.currentUser) {
            const user = $store.currentUser;
            $store.registered = { state: 'registering' };
            store.set($store);
            await api.register({
                address: user.address,
                domain: config.domain,
                signature,
                domainUsername: options?.domainUsername,
                name: options?.name
            }, {
                privateKey: user.delegatePrivateKey
            });
            $store.registered = { state: 'loading' };
            store.set($store);
            const { domainUser } = await api.getDomainUser({
                address: user.address,
                domain: config.domain
            });
            $store.registered = {
                state: 'ready',
                confirmed: domainUser ? true : false
            };
            store.set($store);
        }
    }
    return {
        subscribe: store.subscribe,
        register,
        setCurrentUser,
        // TODO remove: markAsAcceptedAndRead
        //   once we handle accepted/naccepted conversation in the UI we do it automatically here
        openConversation: (other, markAsAcceptedAndRead) => {
            if (!config || !api) {
                throw new Error(`no config provided`);
            }
            if (!$store.currentUser) {
                throw new Error(`no current user`);
            }
            const conversationStore = openOneConversation(config, $store.currentUser, {
                address: other
            }, store, markAsAcceptedAndRead);
            return conversationStore;
        }
    };
}
